/*
 * @Author: liuliangliang liuliangliang@sniffgroup.com
 * @Date: 2024-05-29 10:43:07
 * @LastEditors: liuliangliang liuliangliang@sniffgroup.com
 * @LastEditTime: 2024-06-13 17:23:29
 * @FilePath: /Client/src/views/usercenter/UserCenter/components/modules/data.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { t } from '@/plugins/i18n'
export interface FunctionItems {
    name: string;
    icon: string;
    path?: string;

}
/** 默认功能 */
export const defaultFunctions :FunctionItems[] = [
  {
    name: t('店铺配置'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/店铺设置.png',
    path: 'setupShop'
  },
  {
    name: t('我的物料'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/我的物料.png',
    path: 'materials'
  }
]

/** 常用功能列表-2C */
export const allFunctions2C: FunctionItems[] = [
  {
    name: t('API同步订单'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/同步订单.png',
    path: 'SyncOrder'
  },
  {
    name: t('我的订单'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/我的订单.png',
    path: 'OrderList'
  },
  {
    name: t('异常订单'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/异常订单.png',
    path: 'AbnormalOrder'
  },
  {
    name: t('库存管理'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/库存管理.png',
    path: 'stock'
  },
  {
    name: t('组合商品管理'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/组合商品管理.png',
    path: 'CombinedGoods'
  },
  {
    name: t('品牌授权'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/品牌授权.png',
    path: 'BrandManage'
  },
  {
    name: t('我的商品测量结果'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/商品测量结果.png',
    path: 'Measure'
  },
  {
    name: t('关联商品库'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/关联商品.png',
    path: 'AssociatedProductlib'
  },
  {
    name: t('我的收藏'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/收藏.png',
    path: 'CollectProduct'
  },
  {
    name: t('购买过'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/购买过.png',
    path: 'AfterPurchase'
  },
  {
    name: t('足迹'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/足迹.png',
    path: 'FootPrint'
  },
  {
    name: t('资金明细'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/资金明细.png',
    path: 'CustomerFund'
  },
  {
    name: t('我的账单'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/账单.png',
    path: 'BillList'
  },
  {
    name: t('新增寻源任务'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/新增寻源任务.png',
    path: 'addFindSource'
  },
  {
    name: t('寻源列表'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/寻源列表.png',
    path: 'oemSourceList'
  },
  {
    name: t('OEM商品'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/OEM商品.png',
    path: 'goodsList'
  },
  {
    name: t('店铺配置'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/店铺设置.png',
    path: 'setupShop'
  },
  {
    name: t('API/子账号配置'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/子账号配置.png',
    path: 'AuthorizedStore'
  },
  {
    name: t('会员办理'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/会员办理.png',
    path: 'VipLevel'
  },
  {
    name: t('消息'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/消息.png',
    path: 'Information'
  },
  {
    name: t('登录账号管理'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/账号管理.png',
    path: 'setupUser'
  },
  {
    name: t('成本计算器'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/计算器.png',
    path: 'costCalcList'
  },
  {
    name: t('我的物料'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/我的物料.png',
    path: 'materials'
  }
]

/** 常用功能列表-2B */
export const allFunctions2B: FunctionItems[] = [
  {
    name: t('我的订单'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/我的订单.png',
    path: 'OrderList'
  },
  {
    name: t('异常订单'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/异常订单.png',
    path: 'AbnormalOrder'
  },
  {
    name: t('库存管理'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/库存管理.png',
    path: 'stock'
  },
  {
    name: t('组合商品管理'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/组合商品管理.png',
    path: 'CombinedGoods'
  },
  {
    name: t('同步商品'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/同步商品.png',
    path: 'SyncProduct'
  },
  {
    name: t('品牌授权'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/品牌授权.png',
    path: 'BrandManage'
  },
  {
    name: t('我的商品测量结果'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/商品测量结果.png',
    path: 'Measure'
  },
  {
    name: t('我的收藏'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/收藏.png',
    path: 'CollectProduct'
  },
  {
    name: t('购买过'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/购买过.png',
    path: 'AfterPurchase'
  },
  {
    name: t('足迹'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/足迹.png',
    path: 'FootPrint'
  },
  {
    name: t('FBA补货计划'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/FBA_1.png',
    path: 'ReplenishmentList'
  },
  {
    name: t('国际发货管理'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/国际发货管理.png',
    path: 'ShippingList'
  },
  {
    name: t('国际发货售后'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/国际售后管理.png',
    path: 'AfterSale'
  },
  {
    name: t('资金明细'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/资金明细.png',
    path: 'CustomerFund'
  },
  {
    name: t('我的账单'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/账单.png',
    path: 'BillList'
  },
  {
    name: t('新增寻源任务'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/新增寻源任务.png',
    path: 'addFindSource'
  },
  {
    name: t('寻源列表'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/寻源列表.png',
    path: 'oemSourceList'
  },
  {
    name: t('OEM商品'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/OEM商品.png',
    path: 'goodsList'
  },
  {
    name: t('店铺配置'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/店铺设置.png',
    path: 'setupShop'
  },
  {
    name: t('API/子账号配置'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/子账号配置.png',
    path: 'AuthorizedStore'
  },
  {
    name: t('会员办理'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/会员办理.png',
    path: 'VipLevel'
  },
  {
    name: t('消息'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/消息.png',
    path: 'Information'
  },
  {
    name: t('登录账号管理'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/账号管理.png',
    path: 'setupUser'
  },
  {
    name: t('成本计算器'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/计算器.png',
    path: 'costCalcList'
  },
  {
    name: t('我的物料'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/我的物料.png',
    path: 'materials'
  }
]

enum ENUM_SHOP_PLATFORM {
    /** base */
    BASE = 1,
    /** shopify */
    SHOPIFY,
    /** stores */
    STORES,
    /** amazon */
    AMAZON,
    /** cafe24 */
    CAFE_24,
}

/** 店铺平台logo */
export const mapShopPlatform = new Map([
  [
    ENUM_SHOP_PLATFORM.BASE, {
      icon: require('@/assets/image/icon/base.png')
    }
  ],
  [
    ENUM_SHOP_PLATFORM.SHOPIFY, {
      icon: require('@/assets/image/icon/shopify.png')
    }
  ],
  [
    ENUM_SHOP_PLATFORM.STORES, {
      icon: require('@/assets/image/icon/stores.png')
    }
  ],
  [
    ENUM_SHOP_PLATFORM.AMAZON, {
      icon: require('@/assets/image/icon/amazon.png')
    }
  ],
  [
    ENUM_SHOP_PLATFORM.CAFE_24, {
      icon: require('@/assets/image/shop_cafe24.png')
    }
  ]
])

export enum ENUM_TEMPLATE_LEVEL {
    /** 经济舱 */
    LEVEL_1 = 1,
    /** 标准舱 */
    LEVEL_2,
    /** 商务舱 */
    LEVEL_3,
    /** 头等舱 */
    LEVEL_4,
    /** Pro会员 */
    LEVEL_5,
}

export const mapLevelSign = new Map([
  [
    ENUM_TEMPLATE_LEVEL.LEVEL_1,
    {
      icon: require('@/assets/image/vipImg/vip_sign_1.png')
    }
  ],
  [
    ENUM_TEMPLATE_LEVEL.LEVEL_2,
    {
      icon: require('@/assets/image/vipImg/vip_sign_2.png')
    }
  ],
  [
    ENUM_TEMPLATE_LEVEL.LEVEL_3,
    {
      icon: require('@/assets/image/vipImg/vip_sign_3.png')
    }
  ],
  [
    ENUM_TEMPLATE_LEVEL.LEVEL_4,
    {
      icon: require('@/assets/image/vipImg/vip_sign_4.png')
    }
  ],
  [
    ENUM_TEMPLATE_LEVEL.LEVEL_5,
    {
      icon: require('@/assets/image/vipImg/vip_sign_5.png')
    }
  ]
])

// const vipSign = {
//   level1: require('@/assets/image/vipImg/vip_sign_1.png'),
//   level2: require('@/assets/image/vipImg/vip_sign_2.png'),
//   level3: require('@/assets/image/vipImg/vip_sign_3.png'),
//   level4: require('@/assets/image/vipImg/vip_sign_4.png'),
//   level5: require('@/assets/image/vipImg/vip_sign_5.png')
// }
// export const getVipSign = (level: number) => {
//   if (level === 1) {
//     return vipSign?.level1
//   }
//   if (level === 2) {
//     return vipSign?.level2
//   }
//   if (level === 3) {
//     return vipSign?.level3
//   }
//   if (level === 4) {
//     return vipSign?.level4
//   }
//   if (level === 5) {
//     return vipSign?.level5
//   }
// }
